// define the AppWrite API url and project id
export const AppWriteKeys = {
    endpoint: "https://aw.applikationen.dev:/v1",
    projectId: "605afa9ad24b7",
    // endpoint: "https://aw.cloudfunction.ch/v1",
    // projectId: "5f885e5d6d597",
}

// define all the AppWrite keys for Database Collections
export const AppWriteDB = {
    maxJobs: 100,  //maximum number of jobs we fetch per DB call
    aircraftList: "605b5b0ad3b14",
    fetchLog: "605b5b0af3954",
    // aircraftList: "5f8c439ac94d8",
    // fetchLog: "5f8c3ff42a67e",
}
